
import { defineComponent, PropType } from 'vue';

import { ManageBookingParsedState } from '@white-label-types/stores';
import {
  DATE_TIME_FORMATS,
  formatWithLocale,
  parseISO,
} from '@white-label-helper/date-utilities';

import { getAppVariable } from '@white-label-helper/get-app-variable';

import IconWrapper from '../icon-wrapper/icon-wrapper.vue';
import ModalCenter from '../modal-center/modal-center.vue';
import IconS3 from '@white-label-icon/icons-s3';

export default defineComponent({
  name: 'ModalDifferentDates',

  components: {
    IconS3,
    IconWrapper,
    ModalCenter,
  },

  props: {
    newDateTime: {
      type: String,
      required: true,
    },
    amendItemId: {
      type: String,
      required: true,
    },
    items: {
      type: Array as PropType<ManageBookingParsedState['items']>,
      required: true,
    },
    primaryProductType: {
      type: String,
      required: true,
    },
    dateFormat: {
      type: String,
      default: DATE_TIME_FORMATS.month_day_year,
    },
  },

  computed: {
    lineItems() {
      return this.items
        .map((item) => {
          const dateTimeFromDetails = item.entryExitInfo?.stringEntryTime;
          if (item.id.toString() === this.amendItemId) {
            return {

              title: item.inventory_item.display_name,
              dateTime: parseISO(this.newDateTime),
              dateTimeFormatted: this.formatDateTime(this.newDateTime),
              isPrimary: true,
            };
          }
          const searchCriteria = item.search_criteria[item.product_code];
          const dateTime = `${searchCriteria?.date1} ${searchCriteria?.time1}`

          return {
            title: item.inventory_item.display_name,
            dateTime: parseISO(dateTimeFromDetails || dateTime),
            dateTimeFormatted: this.formatDateTime(dateTimeFromDetails || dateTime),
            isPrimary: false,
          };
        }).sort((a, b) => {
          // Line item for primary product type should be first
          if (a.isPrimary) return -1;
          if (b.isPrimary) return 1;

          // For other line items, sort by date time
          const dateA = a.dateTime;
          const dateB = b.dateTime;
          return dateA - dateB;
        });
    },

    primaryItemName() {
      const primaryItem = this.lineItems.find(item => item.isPrimary);
      return primaryItem ? primaryItem.title : '';
    }
  },

  methods: {
    formatDateTime(dateTimeString: string) {
      const dateTime = parseISO(dateTimeString);
      return formatWithLocale(
        dateTime,
        getAppVariable('poi.country.code') === 'US'
          ? DATE_TIME_FORMATS.weekday_month_day_year_am_pm_lower_case
          : DATE_TIME_FORMATS.weekday_month_day_year_time_24hr_lower_case,
        this.$i18n.locale,
      );
    },
    continueAmendment() {
      this.$emit('continue-amendment');
    },
    goBack() {
      this.$emit('go-back');
    },
  },
});
